import api from './index'

// 获取用户组列表
export const getUserGroups = (params) => {
  return api.get('/work/user-groups/', { params })
}

// 获取用户组详情
export const getUserGroup = (id) => {
  return api.get(`/work/user-groups/${id}`)
}

// 创建用户组
export const createUserGroup = (data) => {
  return api.post('/work/user-groups/', data)
}

// 更新用户组
export const updateUserGroup = (id, data) => {
  return api.put(`/work/user-groups/${id}`, data)
}

// 删除用户组
export const deleteUserGroup = (id) => {
  return api.delete(`/work/user-groups/${id}`)
}

// 获取权限列表
export const getPermissions = () => {
  return api.get('/work/auth/permissions')
}

// 为用户组添加成员
export const addMembersToUserGroup = (userGroupId, userIds) => {
  return api.post(`/work/user-groups/${userGroupId}/add-members`, { userIds })
}

// 从用户组移除成员
export const removeMembersFromUserGroup = (userGroupId, userIds) => {
  return api.post(`/work/user-groups/${userGroupId}/remove-members`, { userIds })
}

export const getAccessibleUserGroups = () => {
  return api.get('/work/user-groups/accessible')
}